/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import PeopleTableBodyContainer from 'components/PeopleTableBodyContainer.jsx';
import PeopleTableSuperActions from 'components/PeopleTableSuperActions.jsx';
import SmartTable from 'components/SmartTable.jsx';
import Group from 'entities/Group';

const FILTERS = [
  {
    name: 'roles',
    options: [
      { key: 'admin', name: 'Admins', eventElementName: 'filter_roles_admins' },
      { key: 'teacher', name: 'Teachers', eventElementName: 'filter_roles_teachers' },
      { key: 'parent', name: 'Parents', eventElementName: 'filter_roles_parents' },
      { key: 'student', name: 'Students', eventElementName: 'filter_roles_students' },
      { key: 'unknown', name: 'No role', eventElementName: 'filter_roles_no_role' },
    ],
  },
];

const nameSorts = [
  { key: 'first_name_asc', name: 'First name ascending' },
  { key: 'first_name_desc', name: 'First name descending', lastInSection: true },
  { key: 'last_name_asc', name: 'Last name ascending' },
  { key: 'last_name_desc', name: 'Last name descending' },
];

const dateJoinedSorts = [
  { key: 'join_date_desc', name: 'Descending' },
  { key: 'join_date_asc', name: 'Ascending' },
];

const roleSorts = [
  { key: 'role_desc', name: 'Descending' },
  { key: 'role_asc', name: 'Ascending' },
];

const CHECKBOX_COLUMN = { key: 'checkbox', name: '' };
const getNameColumn = (sortable: boolean) => ({
  key: 'name',
  name: 'Name',
  sorts: sortable ? nameSorts : null,
});
const getRoleColumn = (sortable: boolean) => ({
  key: 'role',
  name: 'Role',
  sorts: sortable ? roleSorts : null,
});
const getDateColumn = (sortable: boolean) => ({
  key: 'date_joined',
  name: 'Date joined',
  sorts: sortable ? dateJoinedSorts : null,
});
const FAMILY_COLUMN = { key: 'family_members', name: 'Family members' };
const ACTIONS_COLUMN = { key: 'actions', name: 'Actions' };

const INITIAL_SORT = 'first_name_asc';

type Props = {
  group: ?Group,
  namespace: string,
  selectedMembershipsSize?: number,
  headerActions?: any,
  adminConsoleAccess: ?boolean,
};

function PeopleTable(props: Props) {
  const namespace = `people-list-${props.namespace}`;
  const { adminConsoleAccess, group } = props;
  const canViewFamily = group && !!group.getPermissions().can_view_family;

  const columns = [];

  if (adminConsoleAccess) {
    columns.push(CHECKBOX_COLUMN);
  }

  columns.push(getNameColumn(group ? !group.isRoot() : false));

  if (group && group.getOrganization()) {
    columns.push(getRoleColumn(true));
  }

  if (group && !group.isRoot()) {
    columns.push(getDateColumn(true));
  }

  if (canViewFamily) {
    columns.push(FAMILY_COLUMN);
  }

  columns.push(ACTIONS_COLUMN);

  return (
    <div>
      {group && <PeopleTableSuperActions group={group} />}
      <SmartTable
        columns={columns}
        filters={group && group.getOrganization() ? FILTERS : []}
        hasActions
        headerActions={props.headerActions || null}
        initialSort={INITIAL_SORT}
        namespace={namespace}
        searchPlaceholder="Search people"
        withSearch
        data-test="smart-table">
        {({ query, sort, filters }) =>
          group && (
            <PeopleTableBodyContainer
              sort={sort}
              query={query}
              filters={filters}
              group={group}
              adminConsoleAccess={adminConsoleAccess}
              canViewFamily={canViewFamily}
            />
          )
        }
      </SmartTable>
    </div>
  );
}

function mapStateToProps(state: any, props: Props) {
  if (!props.group) {
    return {};
  }

  const table = state.peopleTables.get(props.group.id);

  return {
    selectedMembershipsSize: table ? table.selectedMemberships.size : undefined,
  };
}

export { PeopleTable };
// $FlowFixMe
export default connect(
  mapStateToProps,
  undefined
)(PeopleTable);
